import { render } from "./ProsesBerita.vue?vue&type=template&id=28b1b438"
import script from "./ProsesBerita.vue?vue&type=script&lang=js"
export * from "./ProsesBerita.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__